import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  DepositBonusAmount,
  DepositBonusAvailability,
  DepositBonusCalculateRequest,
  DepositBonusList,
} from '@personal-area/global/deposit-bonus';
import { IS_API_GATEWAY, IS_PRIVATE_API } from '@personal-area/global/http/models';

export const depositBonusURLs = {
  bonusAvailability: (accountId: number): string =>
    `/v1/deposit-bonus/${accountId}/bonus-availability`,
  bonusesByAccountID: (accountId: number): string =>
    `/v1/deposit-bonus/${accountId}/bonus-list`,
  calculateBonus: `/v1/deposit-bonus/calculate`,
};

@Injectable()
export class DepositBonusApiService {
  constructor(private _http: HttpClient) {}

  public getDepositBonusAvailability(
    accountId: number,
    lang: string
  ): Observable<DepositBonusAvailability> {
    return this._http.get<DepositBonusAvailability>(
      depositBonusURLs.bonusAvailability(accountId),
      {
        params: { lang },
        context: new HttpContext().set(IS_PRIVATE_API, true).set(IS_API_GATEWAY, true),
      }
    );
  }

  public getDepositBonusList(accountId: number): Observable<DepositBonusList> {
    return this._http.get<DepositBonusList>(
      depositBonusURLs.bonusesByAccountID(accountId),
      {
        context: new HttpContext().set(IS_PRIVATE_API, true).set(IS_API_GATEWAY, true),
      }
    );
  }

  public getDepositBonusAmount(
    request: DepositBonusCalculateRequest
  ): Observable<DepositBonusAmount> {
    return this._http.post<DepositBonusAmount>(depositBonusURLs.calculateBonus, request, {
      context: new HttpContext().set(IS_PRIVATE_API, true).set(IS_API_GATEWAY, true),
    });
  }
}
